import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "tnfood-cookie-consent";

// Bandeau de consentement cookies conforme CNIL :
// Accepter / Refuser / Personnaliser, égale visibilité, aucune case pré-cochée.
export const CookieBanner = ({ openSignal = 0 }) => {
  const [visible, setVisible] = useState(false);
  const [customize, setCustomize] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  useEffect(() => {
    if (openSignal > 0) {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        try { setAnalytics(!!JSON.parse(saved).analytics); } catch { /* ignore */ }
      }
      setCustomize(true);
      setVisible(true);
    }
  }, [openSignal]);

  const save = (value) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...value, date: new Date().toISOString() }));
    setVisible(false);
    setCustomize(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Consentement aux cookies"
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[60] bg-encre text-cream p-5 md:p-6 shadow-2xl"
    >
      <div className="container mx-auto max-w-7xl">
        <p className="text-sm md:text-base leading-relaxed">
          Nous utilisons des cookies strictement nécessaires au fonctionnement du site et, avec votre accord, des cookies de
          mesure d'audience. Vous pouvez accepter, refuser ou personnaliser votre choix. Consultez notre{" "}
          <Link to="/politique-de-confidentialite" data-testid="cookie-privacy-link" className="underline underline-offset-4 text-gold">
            politique de confidentialité
          </Link>.
        </p>
        {customize && (
          <label className="mt-4 flex items-center gap-3 text-sm" data-testid="cookie-analytics-option">
            <input
              type="checkbox"
              checked={analytics}
              onChange={(e) => setAnalytics(e.target.checked)}
              className="h-4 w-4 accent-saffron"
              data-testid="cookie-analytics-checkbox"
            />
            Cookies de mesure d'audience (statistiques anonymes de fréquentation)
          </label>
        )}
        <div className="mt-4 flex flex-wrap gap-3">
          <button
            type="button"
            data-testid="cookie-accept"
            onClick={() => save({ necessary: true, analytics: true })}
            className="rounded-full bg-saffron text-encre font-semibold px-6 py-2.5 text-sm transition-colors hover:bg-gold"
          >
            Tout accepter
          </button>
          <button
            type="button"
            data-testid="cookie-refuse"
            onClick={() => save({ necessary: true, analytics: false })}
            className="rounded-full border border-cream/60 text-cream font-semibold px-6 py-2.5 text-sm transition-colors hover:bg-cream/10"
          >
            Tout refuser
          </button>
          {customize ? (
            <button
              type="button"
              data-testid="cookie-save-custom"
              onClick={() => save({ necessary: true, analytics })}
              className="rounded-full border border-cream/60 text-cream font-semibold px-6 py-2.5 text-sm transition-colors hover:bg-cream/10"
            >
              Enregistrer mes choix
            </button>
          ) : (
            <button
              type="button"
              data-testid="cookie-customize"
              onClick={() => setCustomize(true)}
              className="rounded-full border border-cream/60 text-cream font-semibold px-6 py-2.5 text-sm transition-colors hover:bg-cream/10"
            >
              Personnaliser
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
